/**
 * Fly-to-cart animation for Tasters Market.
 *
 * Clones the product's image and animates it from the product card up
 * to the header cart icon when a customer adds to cart, then bumps the
 * cart icon. Replaces the cart drawer auto-opening.
 *
 * Toggle: window.themeFlyToCartEnabled (set from theme setting
 *   `cart_add_behavior` in theme.liquid).
 * Debug:  set window.themeFlyToCartDebug = true in the browser console
 *   to see what the script is doing on each add.
 *
 * Listens for `tm:fly-to-cart` dispatched by product-form.js, which
 * carries the originating element in event.detail.trigger.
 */
(function () {
  'use strict';

  var FLY_DURATION = 400; // ms

  function log() {
    if (!window.themeFlyToCartDebug) return;
    try { console.log.apply(console, ['[fly-to-cart]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function getCartIconTarget() {
    return (
      document.getElementById('cart-icon') ||
      document.querySelector('.header-icon-cart') ||
      document.getElementById('cart-icon-bubble')
    );
  }

  // Find the product card wrapper for a given trigger element.
  // Walks up the DOM ancestors and returns the first one that contains
  // a `.product-card__image` (i.e. the smallest container that is a card).
  function findProductCard(triggerEl) {
    if (!triggerEl) return null;

    // Fast path: direct .product-card__wrapper ancestor (the actual class
    // used by snippets/product-card.liquid).
    var direct = triggerEl.closest && triggerEl.closest('.product-card__wrapper');
    if (direct) return direct;

    // Generic walk-up: nearest ancestor with a product image descendant.
    var node = triggerEl;
    var hops = 0;
    while (node && node.nodeType === 1 && hops < 15) {
      if (node.querySelector && node.querySelector('.product-card__image, .product-card__image-wrapper img')) {
        return node;
      }
      node = node.parentNode;
      hops++;
    }
    return null;
  }

  function findProductImage(triggerEl) {
    var card = findProductCard(triggerEl);
    if (!card) {
      log('no product card found from trigger', triggerEl);
      return null;
    }
    // Prefer the active image in a carousel, then the first product-card image, then any img.
    var img =
      card.querySelector('.product-card__image.is-active') ||
      card.querySelector('.product-card__image') ||
      card.querySelector('.product-card__image-wrapper img') ||
      card.querySelector('img');
    if (!img) log('card found, but no image inside', card);
    return img;
  }

  function bumpCartIcon(target) {
    if (!target) return;
    target.classList.remove('tm-cart-bump');
    void target.offsetWidth; // force reflow so the keyframes restart
    target.classList.add('tm-cart-bump');
    setTimeout(function () { target.classList.remove('tm-cart-bump'); }, 600);
  }

  function fly(triggerEl) {
    log('fly() called with trigger:', triggerEl);

    var target = getCartIconTarget();
    if (!target) {
      log('cart icon target not found in DOM');
      return;
    }

    var img = findProductImage(triggerEl);
    if (!img) {
      bumpCartIcon(target);
      return;
    }

    var imgRect = img.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();

    if (imgRect.width === 0 || imgRect.height === 0) {
      log('image has zero size, skipping fly', img);
      bumpCartIcon(target);
      return;
    }

    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.className = 'tm-fly-clone';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    document.body.appendChild(clone);

    var startX = imgRect.left + imgRect.width / 2;
    var startY = imgRect.top + imgRect.height / 2;
    var targetX = targetRect.left + targetRect.width / 2;
    var targetY = targetRect.top + targetRect.height / 2;
    var deltaX = targetX - startX;
    var deltaY = targetY - startY;

    log('animating from', { startX: startX, startY: startY }, 'to', { targetX: targetX, targetY: targetY });

    // Kick off the transition on the next frame so the browser commits
    // the initial styles before transitioning.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transition =
          'transform ' + FLY_DURATION + 'ms cubic-bezier(0.55, -0.2, 0.3, 1), ' +
          'opacity ' + FLY_DURATION + 'ms ease-in';
        clone.style.transform = 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.15)';
        clone.style.opacity = '0.35';
      });
    });

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
      bumpCartIcon(target);
    }
    clone.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, FLY_DURATION + 200);
  }

  document.addEventListener('tm:fly-to-cart', function (event) {
    log('tm:fly-to-cart received. enabled =', !!window.themeFlyToCartEnabled);
    if (!window.themeFlyToCartEnabled) return;
    var trigger = event && event.detail ? event.detail.trigger : null;
    try {
      fly(trigger);
    } catch (e) {
      log('error during fly:', e);
      var t = getCartIconTarget();
      if (t) bumpCartIcon(t);
    }
  });
})();
